import { render, staticRenderFns } from "./AssignmentLeftPanel.vue?vue&type=template&id=7dd925ce&scoped=true&"
import script from "./AssignmentLeftPanel.vue?vue&type=script&lang=js&"
export * from "./AssignmentLeftPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentLeftPanel.vue?vue&type=style&index=0&id=7dd925ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd925ce",
  null
  
)

export default component.exports